// Patch 008.6 — App is now a thin entry that defers to Layout for
// chassis rendering. The shell + header + nav + sub-nav structure all
// live in components/Layout.tsx so route-aware behavior is centralized.

import { Layout } from './components/Layout'

export function App(): JSX.Element {
  return <Layout />
}

export function HomePage(): JSX.Element {
  const OAKRIDGE_ID = '00000000-0a17-0000-0000-000000000001'
  return (
    <section className="hcc-home">
      <header className="hcc-page-header">
        <div className="hcc-page-header__title-block">
          <h1 className="hcc-page-header__title">Heritage Command Center — Core OS</h1>
          <span className="hcc-page-header__stats">Track 2 redesign · single project</span>
        </div>
      </header>
      <p>
        This surface is the Track 2 redesign. Open the Oakridge project at{' '}
        <code>/projects/{OAKRIDGE_ID}/plan/scope</code>, or pick a section from
        the nav above.
      </p>
    </section>
  )
}
